<template>
  <div id="app" :class="{ fixHeight: isAuthenticated == true }">
    <div class="page columns">
      <div class="sidenav column is-one-fifth is-2-fullhd" v-if="isAuthenticated === true && $options.filters.nameInRoute($route.name, 'landing') === false">
        <SideNav v-if="($options.filters.nameInRoute($route.name, 'contracts')) === false && ($options.filters.nameInRoute($route.name, 'contractmanagement')) === false && ($options.filters.nameInRoute($route.name, 'riskmanagement') && userData.user_type !== 'supplier') === false" />
        <ContractsSideNav v-if="($options.filters.nameInRoute($route.name, 'contracts')) === true || ($options.filters.nameInRoute($route.name, 'contractmanagement')) === true" />
        <RiskManagementSideNav v-if="($options.filters.nameInRoute($route.name, 'riskmanagement') && userData.user_type !== 'supplier') === true" />
      </div>
      <div class="page__main column">
        <div class="columns is-multiline main" :class="{ loggedInContent: isAuthenticated == true }">
          <div class="topnav column is-12" v-if="isAuthenticated === true">
            <TopNav />
          </div>
          <div class="column is-12">
            <router-view/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WebSocketService from '@/services/notifications/notifications_websocket'
import Cookies from 'js-cookie'
const SideNav = () => import('@/components/SideNav')
const TopNav = () => import('@/components/TopNav')
const ContractsSideNav = () => import('@/components/ContractsSideNav')
const RiskManagementSideNav = () => import('@/components/RiskManagementSideNav')
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  data() {
    return {
      login: true,
    }
  },
  components: {
    SideNav,
    TopNav,
    ContractsSideNav,
    RiskManagementSideNav
  },
  computed: {
    ...mapGetters('Auth',['isAuthenticated', 'authError', 'authStatus']),
    ...mapGetters('User',['userData',])    
  },
  watch: {
    isAuthenticated() {
      if (this.isAuthenticated === true) {
        window.toast.fire({
            icon: 'success',
            title: this.$t('Login successful'),
        })
        this.connectWebSocket()
      } else {
        window.toast.fire({
            icon: 'success',
            title: this.$t('Logged out'),
        })
        WebSocketService.disconnect()
      }
      this.$router.push('/');
    },
    '$i18n.locale': function(newVal) {
      localStorage.setItem('last-locale', newVal)
    }
  },
  created() {
  },
  mounted() {
    // Connect when user is authenticated
    if (this.isAuthenticated === true) {
      this.connectWebSocket()
      
      // Request notification permission
      if ('Notification' in window) {
        Notification.requestPermission()
      }
    }
  },
  beforeDestroy() {
    WebSocketService.disconnect();
  },
  methods: {
    connectWebSocket() {
      const accessToken = Cookies.get('tendersure_token')
      if (accessToken) {
        WebSocketService.connect(accessToken);
      }
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Roboto:400,900,700,500,300,100');
@import '~bulma';
@import '~@creativebulma/bulma-collapsible';

#app {
  font-family: Roboto;
  font-style: normal;
  line-height: 25px;
  background-color: $color-white-main;
  position: relative;

  .sidenav {
    background: #F9FBFF;
    height: 100vh;
    @include grid_column;
    overflow-y: scroll;
    overflow-x: hidden;
    @include scroll-bar;
    z-index: 100;
    position: relative;
  }

  .topnav {
    width: 100%;
    padding: 0;
    position: sticky;
    top: 0;
    z-index: 100;
  }

  .page__main {
    background-color: $color-white-main;
    overflow: hidden;
    padding: 0.75rem 0 !important;
    padding-bottom: 0;

    .main {
      width: 100%;
      margin: 0;
    }

    .loggedInContent {
      height: 100vh;
      @include grid_column;
      overflow-y: scroll;
      @include scroll-bar;
      justify-content: flex-start;
    }
  }

  .slick-dots {
    margin-left: $line-height*2 !important;
    margin-top: -10vh !important;
    text-align: left !important;
    position: relative !important;

    li {
      width: auto;
      margin: 0;

      button {
        width: 12px;
        height: 12px;
        // padding: 0;

        &:before {
          width: 12px;
          height: 12px;
          color: $color-white-main !important;
        }
        // &:before {
        //   color: $color-white-main !important;
        //   height: 4px;
        //   width: 4px;
        //   line-height: 4px;
        //   background-color: $color-white-main;
        // }
      }
    }

    .slick-active {
      button {
        &:before {
          // width: 24px;
          height: 6px;
          color: $color-white-main !important;
          border-radius: $line-height/4;
          // background-color: $color-white-main;
        }
        // &:before {
        //   // width: 24px;
        //   // height: 6px;
        //   // border-radius: $line-height/4;
        //   color: $color-white-main !important;
        //   // background-color: $color-white-main !important;
        // }
      }
    }
  }
}

.fixHeight {
  height: 100vh;
  width: 100%;
  overflow: hidden;
}

.vs__dropdown-toggle {
    border-radius: 12px !important;
    padding: 4px 12px !important;
}

.vs__dropdown-menu {
  margin-left: 0 !important;
}

.vs__search::placeholder {
  color: $color-gray-medium !important;
}

.pdf-document-view {
  border: 1px solid lightgrey;
}

.back {
  cursor: pointer;
}

.no-copy {
  user-select:none;
}

.vs__actions {
  display: none !important;
}

.country-page-title {
  display: flex;
  align-items: center;

  /*
  &__flag .flag {
  }
  */
}

.allBiddersPage {
  .VuePagination__count {
    display: none;
  }
}

.input, p, label, .label, .swal2-html-container {
  font-size: $font-size-small;
}

.font-size-small {
  font-size: $font-size-small;
}

.swal2-title {
  font-size: $font-size-text !important;
}

.swal2-html-container, .swal2-confirm, .swal2-cancel, .swal2-deny, .swal2-input, .swal2-textarea {
  font-size: $font-size-small !important;
}

.module-name {
  font-size: $font-size-title;
  color: $color-blue-main;
  margin-top: 8px;
  margin-bottom: 12px;
  font-size: $font-size-small;
  font-weight: 600;
}

.red-text {
  color: $color-red-main;
}

.important-alert {
  &__banner {
    strong {
      color: $color-white-main !important;
    }

    color: $color-white-main !important;
    padding: 4px;
  }

  &__reason {
    padding: 4px;
  }
}

.important-alert-blue {
  border: 2px solid $color-blue-medium;

  .important-alert__banner {
    background-color: $color-blue-medium;
  }
}

.important-alert-red {
  border: 2px solid $color-red-main;

  .important-alert__banner {
    background-color: $color-red-main;
  }
}

.important-alert-green {
  border: 2px solid $color-green-main;

  .important-alert__banner {
    background-color: $color-green-main;
  }
}

.modal-styles {
  .button-link {
    color: $color-white-main;
    background-color: $color-blue-main;
    border: none;
    font-size: $font-size-small;

    @media screen and (max-width: 1600px) {
        font-size: $font-size-small;
    }
  }
  .mysearch {
    position: relative;

    &--icon {
        color:rgba(18, 31, 62, 0.8);
        margin: $line-height/2 0;
        margin-left: 24px;
        z-index: 30;
        position: absolute;
        cursor: pointer;
    }

    &--input {
        color: $color-black-medium;
        background: #F2F7FF;
        border-radius: $line-height/2;
        padding: $line-height/2 $line-height*2;
        border: none;
        z-index: 10;
        font-size: $font-size-text;

        &:focus {
            outline: none !important;
        }
    }
  }
}

.large-modal {
  margin: 0 auto;
  width: 70vw;         /* or a fixed width like 800px */
  max-width: 70vw;
}
.blue {
    color: #073a82;
}
.green {
    color: #4CAF50;
}
.red {
    color: #F44336;
}
.amber {
    color: #FF9800;
}

.cursor-pointer {
  cursor: pointer;
}

.is-primary {
  background-color: #073a82 !important;
}

.hr{
  margin: 0rem 0 !important;
}

.blur-text {
  filter: blur(4px);
}

.VueTables__filters-row {
  display: none;
}

.pending-approval-action {
  background-color: $color-baby-blue;
  color: $color-green-main;
  font-weight: bold;

  strong {
    color: $color-green-main;
  }
}

.centered {
  text-align: center;
}

.VueTables__table tbody .dropdown-content {
  position:  relative !important;
}

/* --- Action dropdowns inside data tables ----------------------------------
 * A table's action menu (`.dropdown`) sits several `overflow` containers deep
 * (`.page__main`, `.loggedInContent`, `.page__content`, and `.table-responsive`,
 * which clips vertically because `overflow-x: scroll` forces `overflow-y: auto`).
 * Bulma positions the menu absolutely inside the row, so those ancestors clip
 * it: on a short table, or on the last row, it opens outside the visible area
 * and the user has to scroll to reach it.
 *
 * Switching the OPEN menu to `position: fixed` takes it out of that overflow
 * chain (nothing here establishes a fixed-positioning containing block, so it
 * escapes every clip). `src/utils/tableActionMenu.js` then gives it real
 * coordinates next to its trigger button and flips it above when there is no
 * room below. The `top`/`left` here are only the pre-measurement defaults.
 *
 * Scoped to `.VueTables` on purpose so the sidenav's own `.dropdown` menus
 * (BuyerNav / SideNav / SupplierNav / QEDNav) keep their existing behaviour.
 */
.VueTables .dropdown.is-active .dropdown-menu {
  position: fixed;
  top: auto;
  bottom: auto;
  left: auto;
  right: auto;
  z-index: 200;
}

.VueTables .dropdown.is-active .dropdown-content {
  /* keep the menu usable when it opens near a screen edge */
  max-height: 60vh;
  overflow-y: auto;
}
</style>
